/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Progress_Lifts_MetaInputs */

const en_us2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last ${i?.weeks} weeks`)
};

const pt_br2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`últimas ${i?.weeks} semanas`)
};

const es_419_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`últimas ${i?.weeks} semanas`)
};

const pt_pt2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`últimas ${i?.weeks} semanas`)
};

const fr_fr2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} dernières semaines`)
};

const de_de2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`letzte ${i?.weeks} Wochen`)
};

const it_it2_progress_lifts_meta = /** @type {(inputs: Progress_Lifts_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ultime ${i?.weeks} settimane`)
};

/**
* | output |
* | --- |
* | "last {weeks} weeks" |
*
* @param {Progress_Lifts_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_meta = /** @type {((inputs: Progress_Lifts_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_meta(inputs)
	if (locale === "es-419") return es_419_progress_lifts_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_meta(inputs)
	return en_us2_progress_lifts_meta(inputs)
});
export { progress_lifts_meta as "progress.lifts_meta" }